import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { LOCALES_QUERY } from '../../queries';

export function useLocalesQuery( options ) {

    const { data: rawData, loading, error, refetch } = useQuery( LOCALES_QUERY, {
        ...options 
    } );

    return useMemo( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ error, loading, rawData, refetch ] );
}
